var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef, useCallback } from "react";
import { useSnackbar, SnackbarContent } from "notistack";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React from "react";
import "../../scss/main.scss";
import "./alert.scss";
import { Grid } from "@mui/material";
const SuccessAlert = forwardRef((_a, ref) => {
    var { id } = _a, props = __rest(_a, ["id"]);
    const { closeSnackbar } = useSnackbar();
    const handleDismiss = useCallback(() => {
        closeSnackbar(id);
    }, [id, closeSnackbar]);
    return (React.createElement(SnackbarContent, { ref: ref },
        React.createElement(Card, { className: "al_border_success al_card" },
            React.createElement(CardActions, null,
                React.createElement(Grid, { container: true, direction: "row", justifyContent: "space-between", alignItems: "center", gap: 1 },
                    React.createElement(Grid, { item: true, xs: 0.9, marginBottom: "-4px", textAlign: "right" },
                        React.createElement(CheckCircleIcon, { fontSize: "small", className: "al_success" })),
                    React.createElement(Grid, { item: true, xs: true },
                        React.createElement(Typography, { variant: "body2", fontWeight: 600, className: "m_font_size_14" }, props.message)),
                    React.createElement(Grid, { item: true, container: true, xs: 1, justifyItems: "flex-end" },
                        React.createElement(Grid, { item: true },
                            React.createElement(IconButton, { size: "small", onClick: handleDismiss },
                                React.createElement(CloseIcon, { fontSize: "small", className: "al_close" })))))))));
});
SuccessAlert.displayName = "SuccessAlert";
export default SuccessAlert;
